module.exports = __webpack_public_path__ + "img/person-running.d147c67b.svg";